<script setup lang="ts">
  import { ref } from 'vue';
  import type { DestinationPrices } from '@/entities/searchCriteria';
  import type { AccountUser } from '@/features/account';
  import { SerpLayout, useSerpCriteria } from '@/layouts/serp';
  import { CountryResortsUrl, FormDataUrl, IntelligentSearchUrl } from '@/shared/config/formData';
  import { SearchForm, type SearchFormCriteria, type SearchFormExpose } from '@/widgets/searchForm';

  // Повторяет SerpPageProps из layouts/serp: compiler-sfc Vue 2.7 не резолвит импортированный
  // тип в defineProps, поэтому контракт страницы объявлен здесь.
  interface HotSearchProps {
    modelValue?: SearchFormCriteria | null;
    user?: AccountUser | null;
    accountUrl?: string;
    prices?: DestinationPrices;
    isVisibleRoomButton?: boolean;
    departureDisabled?: boolean;
    destinationDisabled?: boolean;
  }

  const props = withDefaults(defineProps<HotSearchProps>(), {
    modelValue: null,
    isVisibleRoomButton: false,
  });

  interface HotSearchEmits {
    (e: 'update:modelValue', criteria: SearchFormCriteria): void;
    (e: 'search', criteria: SearchFormCriteria): void;
    (e: 'login'): void;
    (e: 'logout'): void;
    (e: 'buy'): void;
  }
  const emit = defineEmits<HotSearchEmits>();

  const searchFormRef = ref<SearchFormExpose | null>(null);
  const criteria = useSerpCriteria(props, emit);

  defineExpose<SearchFormExpose>({
    validate: () => (searchFormRef.value ? searchFormRef.value.validate() : true),
    submit: () => searchFormRef.value?.submit(),
    reset: () => searchFormRef.value?.reset(),
  });
</script>

<script lang="ts">
  export default {
    model: {
      prop: 'modelValue',
      event: 'update:modelValue',
    },
  };
</script>

<template>
  <SerpLayout
    :user="user"
    :account-url="accountUrl"
    @login="emit('login')"
    @logout="emit('logout')"
    @buy="emit('buy')"
  >
    <template #form="{ collapsed }">
      <SearchForm
        ref="searchFormRef"
        v-model="criteria"
        :rounded-bottom="collapsed"
        :prices="prices"
        :is-visible-room-button="isVisibleRoomButton"
        :departure-disabled="departureDisabled"
        :destination-disabled="destinationDisabled"
        :form-url="FormDataUrl.Hot"
        :search-url="IntelligentSearchUrl.Hot"
        :resorts-url="CountryResortsUrl.Hot"
        @search="emit('search', $event)"
      />
    </template>
  </SerpLayout>
</template>
